/* BackToTopButton.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _throttle from "lodash/throttle";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "._1in31kr1 .backToTopButtonFadeOut.backToTopButtonFadeOutActive{transition:opacity .3s ease-in}";
const _11 = "._1qahidpf .backToTopButtonFadeOut.backToTopButtonFadeOutActive{opacity:0}";
const _10 = "._1jlakb7n .backToTopButtonFadeOut{opacity:1}";
const _9 = "._s1aw1kr1 .backToTopButtonFadeIn.backToTopButtonFadeInActive{transition:opacity .3s ease-in}";
const _8 = "._1k27kb7n .backToTopButtonFadeIn.backToTopButtonFadeInActive{opacity:1}";
const _7 = "._voz2idpf .backToTopButtonFadeIn{opacity:0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ArrowUpIcon from '@atlaskit/icon/glyph/arrow-up';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Button } from '../Buttons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _6 = "._2rko1y44{border-radius:4px}";
const _5 = "._16qs12fg{box-shadow:0 4px 6px 5px rgba(66,82,110,.16)}";
const _4 = "._bfhk6ota{background-color:var(--ds-surface)}";
const _3 = "._1xi21ejb{right:var(--ds-space-300,24px)}";
const _2 = "._94n51ejb{bottom:var(--ds-space-300,24px)}";
const _ = "._kqsw1n9t{position:fixed}";
function getScrollParent(node) {
  var _window;
  if (node == null || !(node instanceof Element)) {
    return null;
  }
  let overflowY;
  if ((_window = window) !== null && _window !== void 0 && _window.getComputedStyle) {
    overflowY = window.getComputedStyle(node).overflowY;
  }
  const isScrollable = overflowY === 'auto' || overflowY === 'scroll';
  if (isScrollable && node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}
export const ButtonContent = _ref => {
  let {
    backToTopClickHandler
  } = _ref;
  return /*#__PURE__*/_jsx(BackToTopWrapper, {
    children: /*#__PURE__*/_jsx(Button, {
      onClick: backToTopClickHandler,
      iconAfter: /*#__PURE__*/_jsx(ArrowUpIcon, {
        label: ""
      }),
      children: "Back to top"
    })
  });
};
const BackToTopWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kqsw1n9t _94n51ejb _1xi21ejb _bfhk6ota _16qs12fg _2rko1y44", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BackToTopWrapper.displayName = 'BackToTopWrapper';
}
const TransitionGroupContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8, _9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_voz2idpf _1k27kb7n _s1aw1kr1 _1jlakb7n _1qahidpf _1in31kr1", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TransitionGroupContainer.displayName = 'TransitionGroupContainer';
}
let scrollTimeout;
const BackToTopButton = () => {
  const [showBackToTopBtn, setShowBackToTopBtn] = useState(false);
  const prevScrollPosRef = useRef(0);
  const scrollParentRef = useRef(null);
  const componentRef = useRef(null);
  const handleScroll = useCallback(() => {
    const scrollParent = scrollParentRef.current;
    if (!scrollParent) return;
    const currScrollPos = scrollParent.scrollTop;
    const prevScrollPos = prevScrollPosRef.current;
    prevScrollPosRef.current = currScrollPos;
    const isScrollingUp = currScrollPos < prevScrollPos;
    const isScrollWithinThreshold = currScrollPos < window.innerHeight * 4;
    const isScrollInFirstFold = currScrollPos === 0;
    if (!showBackToTopBtn && !isScrollWithinThreshold && isScrollingUp) {
      setShowBackToTopBtn(true);
    } else if (showBackToTopBtn && (!isScrollingUp || isScrollInFirstFold)) {
      setShowBackToTopBtn(false);
    }
    hideAfterTimeout(isScrollingUp);
  }, [showBackToTopBtn]);
  const hideAfterTimeout = isScrollingUp => {
    clearTimeout(scrollTimeout);
    if (isScrollingUp) {
      scrollTimeout = setTimeout(() => {
        setShowBackToTopBtn(false);
      }, 7000);
    }
  };
  useEffect(() => {
    const node = componentRef.current;
    const scrollParent = getScrollParent(node);
    scrollParentRef.current = scrollParent;
    if (scrollParent) {
      const throttledHandleScroll = _throttle(handleScroll, 500);
      scrollParent.addEventListener('scroll', throttledHandleScroll);
      return () => {
        clearTimeout(scrollTimeout);
        scrollParent.removeEventListener('scroll', throttledHandleScroll);
      };
    }
  }, [handleScroll]);
  const backToTopClickHandler = () => {
    const scrollParent = scrollParentRef.current;
    if (scrollParent) {
      scrollParent.scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return /*#__PURE__*/_jsx("div", {
    ref: componentRef,
    children: /*#__PURE__*/_jsx(TransitionGroupContainer, {
      children: /*#__PURE__*/_jsx(TransitionGroup, {
        children: showBackToTopBtn && /*#__PURE__*/_jsx(CSSTransition, {
          classNames: {
            appear: 'backToTopButtonFadeIn',
            appearActive: 'backToTopButtonFadeInActive',
            enter: 'backToTopButtonFadeIn',
            enterActive: 'backToTopButtonFadeInActive',
            exit: 'backToTopButtonFadeOut',
            exitActive: 'backToTopButtonFadeOutActive'
          },
          appear: true,
          exit: true,
          timeout: 500,
          children: /*#__PURE__*/_jsx(ButtonContent, {
            backToTopClickHandler: backToTopClickHandler
          })
        })
      })
    })
  });
};
export { BackToTopButton };